import React from 'react';
import injectSheet from 'react-jss';
import Img from 'gatsby-image';

const ImageSnippet = ({ classes, children, ...other }) => {
    return (
        <div
            className={classes.container}>
            {children}
        </div>
    );
};

const styles = {
    container: {
        width: ({ width = '21.2rem'}) => width,
        height: ({ height = '20rem'}) => height,
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& h1': {
            fontFamily: [ 'Noto Sans SemiBold', 'sans-serif' ],
            fontSize: '1.53rem',
            fontWeight: 'normal',
            marginBottom: 0
        },
        '& p': {
            fontSize: '1.06rem'
        },
        '& a': {
            color: '#3F3F3F',
            textDecoration: 'none'
        }
    }
};

export default injectSheet(styles)(ImageSnippet);



// WEBPACK FOOTER //
// ./src/components/ImageSnippet.js